import React from 'react';

import { Container, Paragraph, FooterButton } from './styles';
import Header from '../../components/HeaderMenuContent';
import NaoAprovado from '../../assets/naoAprovado.png';
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router';
import { useScreenTracking } from '../../hooks/useScreenTracking';
import { trackOrderStatusEvent } from '../../utils/gtm';

const FALLBACK_MESSAGE = "Não foi possível processar o seu pedido. Confira seus dados e tente novamente.";

function cleanBackendMessage(raw) {
    if (!raw) return "";
    let m = String(raw).trim();
    // Drop the "Erro ao criar pedido: " prefix if backend included it
    m = m.replace(/^Erro ao criar pedido:\s*/i, "");
    // If the backend leaked a cURL / gateway trace, fall back to a generic message
    if (/curl error|timed out|libcurl|transactionCreate|http:\/\//i.test(m)) {
        return "";
    }
    return m;
}

export default function OrderNotApproved() {
    const navigate = useNavigate();
    const location = useLocation();
    const screenName = useScreenTracking();

    const cleaned = cleanBackendMessage(location.state?.errorMessage);
    const messageToShow = cleaned || FALLBACK_MESSAGE;

    function goToPayment() {
        trackOrderStatusEvent({
            title: "voltar-para-pagamento",
            contentType: "checkout",
            screenName,
        });
        navigate('/loja/orderresumepag/');
    }

    function goToHome() {
        trackOrderStatusEvent({
            title: "ir-para-home",
            contentType: "checkout",
            screenName,
        });
        navigate('/loja');
    }

    return (
        <>
            <Header />
            <Container>
                <Paragraph>
                    <img src={NaoAprovado} alt="Order" />
                    <p className="title">Pedido não aprovado!</p>
                    <p className="text">{messageToShow}</p>
                </Paragraph>
                <FooterButton>
                    <Button onClick={goToPayment} className="btn-default-wl">VOLTAR PARA PAGAMENTO</Button>
                    <Button onClick={goToHome} className="btn-secondary-wl">IR PARA HOME</Button>
                </FooterButton>
            </Container>
        </>
    )

}
